// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-datepicker-years {
  display: grid;
  grid-template-columns: repeat(4, 60px);
  grid-auto-rows: 40px;
  grid-gap: 6px;
  justify-content: center;
}
.dl-datepicker-years__year {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  cursor: pointer;
}
.dl-datepicker_desktop .dl-datepicker-years__year:hover {
  background-color: var(--g-color-base-simple-hover);
}
.dl-datepicker-years__year_today {
  color: var(--g-color-text-info);
}
.dl-datepicker-years__year_selected {
  border-radius: 0;
  background-color: var(--g-color-base-selection);
}
.dl-datepicker_desktop .dl-datepicker-years__year_selected:hover {
  background-color: var(--g-color-base-selection);
}
.dl-datepicker-years__year_left-edge {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.dl-datepicker-years__year_right-edge {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.dl-datepicker-years__year_selected:not(.dl-datepicker-years__year_left-edge)::before {
  content: "";
  position: absolute;
  top: 0;
  left: -6px;
  display: block;
  height: 40px;
  width: 6px;
  background-color: var(--g-color-base-selection);
}
.dl-datepicker-years__year_disabled {
  opacity: 0.3;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/Datepicker/Years/Years.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sCAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;AACJ;AACI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACR;AACQ;EACI,kDAAA;AACZ;AAEQ;EACI,+BAAA;AAAZ;AAGQ;EACI,gBAAA;EACA,+CAAA;AADZ;AAGY;EACI,+CAAA;AADhB;AAKQ;EACI,2BAAA;EACA,8BAAA;AAHZ;AAMQ;EACI,4BAAA;EACA,+BAAA;AAJZ;AAOQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,+CAAA;AALZ;AAQQ;EACI,YAAA;EACA,oBAAA;AANZ","sourcesContent":[".dl-datepicker-years {\n  display: grid;\n  grid-template-columns: repeat(4, 60px);\n  grid-auto-rows: 40px;\n  grid-gap: 6px;\n  justify-content: center;\n}\n.dl-datepicker-years__year {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.dl-datepicker_desktop .dl-datepicker-years__year:hover {\n  background-color: var(--g-color-base-simple-hover);\n}\n.dl-datepicker-years__year_today {\n  color: var(--g-color-text-info);\n}\n.dl-datepicker-years__year_selected {\n  border-radius: 0;\n  background-color: var(--g-color-base-selection);\n}\n.dl-datepicker_desktop .dl-datepicker-years__year_selected:hover {\n  background-color: var(--g-color-base-selection);\n}\n.dl-datepicker-years__year_left-edge {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.dl-datepicker-years__year_right-edge {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.dl-datepicker-years__year_selected:not(.dl-datepicker-years__year_left-edge)::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -6px;\n  display: block;\n  height: 40px;\n  width: 6px;\n  background-color: var(--g-color-base-selection);\n}\n.dl-datepicker-years__year_disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
